import React, { useState, useEffect } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { toast } from "react-toastify";
import axios from "axios";

const ContactSection = () => {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await fetch(
          "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_contact_info"
        );
        const result = await response.json();
        
        if (result.status && result.data && result.data.length > 0) {
          setContactInfo(result.data[0]);
        } else {
          setError("No contact information available");
        }
      } catch (err) {
        setError("Failed to load contact information");
        console.error("Error fetching contact info:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.message) {
    toast.error("Please fill all required fields");
    return;
  }

  try {
    const payload = {
      name: formData.name,
      email: formData.email,
      massage: formData.message // backend key
    };

    const response = await axios.post(
      "https://cyberathon.com/streekatha/API/index.php/Master_controller/add_contact_us",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Contact API response:", response.data);

    if (response.data.status === "true" || response.data.success === "1") {
      toast.success("Message sent successfully");

      // reset form
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } else {
      toast.error(response.data.message || "Failed to send message");
    }
  } catch (error) {
    console.error("Contact submit error:", error);
    toast.error("Something went wrong. Please try again");
  }
};


  return (
    <section
      className="section-bg"
      style={{
        backgroundImage: "url(https://i.ibb.co/9p3Cnk9/slider-2.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "left",
      }}
      data-scroll-index="7"
    >
      <div
        className="overlay d-flex align-items-center"
        style={{
          background:
            "linear-gradient(to right, rgba(90, 100, 232, 0.9), rgba(84, 96, 234, 0.9))",
          padding: "110px 0",
        }}
      >
        <div className="container">
          <div className="row">
            {/* Left Contact Info */}
            <div className="col-lg-6 d-flex align-items-center">
              <div className="contact-info pe-lg-5">
                <h2 className="text-white mb-4">Have Any Questions?</h2>
                {loading ? (
                  <div className="text-light">
                    <p>Loading contact information...</p>
                  </div>
                ) : error ? (
                  <div className="text-light">
                    <p>{error}</p>
                  </div>
                ) : contactInfo ? (
                  <>
                    <p className="text-light">
                      {contactInfo.description || "Lorem ipsum is a dummy text used to replace text in some areas just for the purpose of an example. It can be used in publishing and graphic design. The lorem ipsum text is usually a section of a Latin text by Cicero with words altered, added and removed to make it nonsensical."}
                    </p>
                    <ul className="list-unstyled mt-4">
                      <li className="d-flex align-items-center mb-3">
                        <div className="me-3">
                          <i className="fas fa-mobile-alt fa-2x text-warning"></i>
                        </div>
                        <div>
                          <h5 className="text-white mb-0">{contactInfo.phone}</h5>
                        </div>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <div className="me-3">
                          <i className="fas fa-at fa-2x text-warning"></i>
                        </div>
                        <div>
                          <h5 className="text-white mb-0">{contactInfo.email}</h5>
                        </div>
                      </li>
                      <li className="d-flex align-items-center mb-3">
                        <div className="me-3">
                          <i className="fas fa-map-marker-alt fa-2x text-warning"></i>
                        </div>
                        <div>
                          <h5 className="text-white mb-0">{contactInfo.address}</h5>
                        </div>
                      </li>
                    </ul>
                  </>
                ) : null}
              </div>
            </div>

            {/* Right Contact Form */}
            <div className="col-lg-6 d-flex align-items-center">
              <div
                className="contact-form bg-white p-4 p-lg-5 shadow rounded"
                style={{ position: "relative", zIndex: 2, width:"600px" }}
              >
                <div id="contact-form">
                  <input type="hidden" name="form-name" value="contactForm" />
                  <div className="mb-3">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="form-control border-bottom border-2 border-secondary"
                      placeholder="Enter Your Name *"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="form-control border-bottom border-2 border-secondary"
                      placeholder="Enter Your Email *"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="4"
                      className="form-control border-bottom border-2 border-secondary"
                      placeholder="Enter Your Message *"
                      required
                    ></textarea>
                  </div>
                  <button 
                    className="btn btn-warning btn-lg mt-3"
                    onClick={handleSubmit}
                  >
                    Send Us <i className="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;